export class SingleRatingResponse {
    public rating: number; // "3.0000",
    public ratable_type: string; // "tip",
    public ratable_id: number; // 48,
    public ratable_slug: string; // "cum-quidem-in-sunt36594",
    public rating_type: string; // "general", or "usefulness" or "all_types_average" (general is different from all_types)
    public my_rating: boolean; // false... if false, the rating is average for all users
  }